(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("pauseLearnerEmailService", ["notificationResource", "$uibModal", pauseLearnerEmailService]);
    function pauseLearnerEmailService(notificationResource, $uibModal) {
        var pauseLearnerEmailServiceFactory = {
            data: {
                learnerEmailsPausedState: null,
                date: null
            }
        };
        var promise = notificationResource.getPauseLearnerEmail().$promise.then(function (result) {
            pauseLearnerEmailServiceFactory.data = result;
            return result;
        }).catch(angular.noop);
        var getData = function () {
            return promise;
        };
        var save = function (model, callback) {
            notificationResource.updatePauseLearnerEmailSettings(model, function () {
                pauseLearnerEmailServiceFactory.data.learnerEmailsPausedState = model.learnerEmailsPausedState;
                if (model.learnerEmailsPausedState === 1)
                    pauseLearnerEmailServiceFactory.data.date = model.date;
                else if (model.learnerEmailsPausedState === 2)
                    pauseLearnerEmailServiceFactory.data.date = null;
                else if (model.learnerEmailsPausedState === 3)
                    pauseLearnerEmailServiceFactory.data.date = null;
                if (callback)
                    callback();
            });
        };
        var openPauseSettings = function () {
            return $uibModal.open({
                templateUrl: "app/settings/notifications/pauseLearnerEmailsModalView.html",
                controller: "PauseLearnerEmailsModalCtrl as vm",
                backdrop: "static"
            }).result.catch(angular.noop);
        };
        pauseLearnerEmailServiceFactory.getData = getData;
        pauseLearnerEmailServiceFactory.save = save;
        pauseLearnerEmailServiceFactory.openPauseSettings = openPauseSettings;
        return pauseLearnerEmailServiceFactory;
    }
}());
